<template>
  <div>
      <div class="level">
          <div class="level-left">
              <h1 class="title">Applications</h1>
          </div>
           <div class="level-right">
              <div class="buttons  is-right">
                <router-link :to="'/contacts/' + this.$route.params.id + '/addapplication'"><button class="button is-info">Add An Old Application</button></router-link>
            
              </div>
            </div>
      </div>
      
        
      
          <table class="table is-fullwidth">
        <thead>
            <tr>
                <th>Date</th>
                <th>Round</th>
                <th>Status</th>
                <th>Sport</th>
            </tr>
            </thead>
            <tbody>
                    <tr valign="top"  v-for="row in applications" v-cloak v-bind:key="row.id">
                        <td ><router-link :to="'/applications/' + row.id">{{row.date}}</router-link></td>
                        <td>{{ row.round_name }}</td>
                        <td>{{ showApplicationStatus(row.endorsed, row.awarded)}}</td>
                        <td >{{ row.governing_body_name }}</td>
                    </tr>
                    
                </tbody>

            </table>

            
            
  </div>
</template>

<script>
//import ApplicationService from '@/services/ApplicationService.js';

  export default {
    props: {
      applications: {}
    },
    created() {
   
      this.getAccessToken()
      .then(() => { 
        
      });
    
   
  },
    methods: {
      
    }
  }
</script>
